export const MODAL_EDIT = 'MODAL_EDIT';
export const MODAL_EDIT_GOOGLE_AUTH = 'MODAL_EDIT_GOOGLE_AUTH';
